const menuButton = document.getElementById('menuButton');
const drawer = document.getElementById('drawer');
const drawerClose = document.getElementById('drawerClose');
const closeVideo = document.getElementById('closeVideo');
const floatingVideo = document.getElementById('floatingVideo');

menuButton?.addEventListener('click', () => drawer?.classList.add('open'));
drawerClose?.addEventListener('click', () => drawer?.classList.remove('open'));
closeVideo?.addEventListener('click', () => {
  if (floatingVideo) floatingVideo.style.display = 'none';
});

// drawer: リンククリックで閉じる → その後スムーズスクロール
(() => {
  if (!drawer) return;

  const closeDrawer = () => drawer.classList.remove('open');
  const waitClose = (ms = 300) => new Promise((r) => setTimeout(r, ms)); // 待ち時間を少し長めに確保

  document.addEventListener(
    'click',
    async (e) => {
      const el = e.target.closest('#drawer a[href], #drawer button[data-close-drawer]');
      if (!el) return;

      if (el.matches('button[data-close-drawer]')) {
        closeDrawer();
        return;
      }

      const href = el.getAttribute('href') || '';

      if (href.startsWith('#')) {
        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        closeDrawer();

        // 1. ドロワーが閉じるのをしっかり待つ
        // これを待たないと、ブラウザが正しい座標を計算できません
        await waitClose(300);

        // 2. 他のリンクと同じ計算式を使う
        const offset = 80; // ★ここで高さを調整
        const container = document.querySelector('.loosy-main');
        
        if (container && container.scrollHeight > container.clientHeight) {
          const top = target.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop - offset;
          container.scrollTo({ top, behavior: 'smooth' });
        } else {
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }

        history.replaceState(null, '', href);
        return;
      }

      closeDrawer();
    },
    true
  );
})();



// cordinate
  (() => {
  const wrap = document.querySelector('.image-list-wrap');
  if (!wrap || wrap.dataset.marqueeInitialized) return;
  wrap.dataset.marqueeInitialized = '1';

  // 継ぎ目なし用に2倍複製
  wrap.querySelectorAll('.line_1, .line_2').forEach(line => {
    if (line.dataset.duped) return;
    line.dataset.duped = '1';
    line.innerHTML += line.innerHTML;
  });

  wrap.querySelectorAll('img').forEach(img => {
    try { img.loading = 'eager'; } catch(e){}
    try { img.decoding = 'async'; } catch(e){}
  });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    wrap.querySelectorAll('.line_1, .line_2').forEach(el => {
      el.style.animation = 'none';
    });
  }
})();

// slider
document.addEventListener('DOMContentLoaded', () => {
const block  = document.querySelector('.point__block--slider');
if (!block) return;

const slides = block.querySelectorAll('.point__slide');
const dots   = block.querySelectorAll('.point__dot');
if (slides.length < 2 || dots.length !== slides.length) return;

let i = 0;
const INTERVAL = 1000; // 1秒ごとに切替（フェードはCSSで1.5s）
let timer = null;

const go = (next) => {
  slides[i].classList.remove('is-active');
  dots[i].classList.remove('is-active');
  i = (next + slides.length) % slides.length;
  slides[i].classList.add('is-active');
  dots[i].classList.add('is-active');
  dots.forEach((d,idx)=> d.setAttribute('aria-selected', idx===i ? 'true':'false'));
};

const start = () => { timer = setInterval(() => go(i+1), INTERVAL); };
const stop  = () => { if (timer) clearInterval(timer); };

// クリックでジャンプ
dots.forEach((dot, idx) => {
  dot.addEventListener('click', () => {
    stop(); go(idx); start();
  });
});

// 省エネ設定なら自動再生オフ
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  block.querySelectorAll('.point__slide').forEach(s => s.style.transition = 'none');
} else {
  start();
}
});

// タブ切り替え
document.addEventListener('DOMContentLoaded', () => {
const tabs = document.querySelectorAll('.products__tab');
const panels = document.querySelectorAll('.products__panel');
const more = document.getElementById('productsMore');

if (!tabs.length) return;

const activate = (targetId, link) => {
  // tabs
  tabs.forEach(t => {
    const on = t.dataset.target === targetId;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  // panels
  panels.forEach(p => {
    const on = p.id === targetId;
    p.classList.toggle('is-active', on);
    p.toggleAttribute('hidden', !on);
  });
  // 一覧ボタン
  if (more && link) more.setAttribute('href', link);
};

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    activate(tab.dataset.target, tab.dataset.link);
  });
});
});

// review
(() => {
const expand = (el) => {
  if (el.dataset.animating === '1') return;
  el.dataset.animating = '1';
  el.hidden = false;
  const h = el.scrollHeight;
  el.style.height = '0px';
  el.style.overflow = 'hidden';
  el.style.transition = 'height .3s ease';
  requestAnimationFrame(() => { el.style.height = h + 'px'; });
  el.addEventListener('transitionend', function end(){
    el.style.height = 'auto';
    el.style.overflow = '';
    el.style.transition = '';
    el.dataset.animating = '0';
    el.removeEventListener('transitionend', end);
  });
};

const collapse = (el) => {
  if (el.dataset.animating === '1') return;
  el.dataset.animinating = '1';
  el.style.overflow = 'hidden';
  el.style.transition = 'height .3s ease';
  el.style.height = el.scrollHeight + 'px';
  requestAnimationFrame(() => { el.style.height = '0px'; });
  el.addEventListener('transitionend', function end(){
    el.hidden = true;
    el.style.height = '';
    el.style.overflow = '';
    el.style.transition = '';
    el.dataset.animating = '0';
    el.removeEventListener('transitionend', end);
  });
};

// イベント委譲：documentに1回だけ
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.reviews__more-btn[aria-controls]');
  if (!btn) return;

  // 対象パネルを aria-controls から取得（フォールバックも用意）
  const id = btn.getAttribute('aria-controls');
  const scope = document.getElementById('reviews') || document;
  let panel = (id && document.getElementById(id)) || scope.querySelector('.reviews__more');
  if (!panel) return;

  const expanded = btn.getAttribute('aria-expanded') === 'true';

  // トグル
  if (expanded) {
    collapse(panel);
  } else {
    expand(panel);
  }

  // aria とテキストだけ更新（アイコン回転はCSS任せ）
  btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  const textEl = btn.querySelector('.btn-text');
  if (textEl) textEl.textContent = expanded ? 'もっと見る' : '閉じる';
});
})();





// slider（設置イメージ）
document.addEventListener('DOMContentLoaded', () => {
const root   = document.querySelector('.placement');
if (!root) return;

const slides = root.querySelectorAll('.placement__slide');
const prev   = root.querySelector('.placement__nav--prev');
const next   = root.querySelector('.placement__nav--next');
const dots   = root.querySelectorAll('.placement__dot');

let i = 0;

const set = (idx) => {
  i = Math.max(0, Math.min(slides.length - 1, idx));
  slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
  dots.forEach((d, n) => {
    d.classList.toggle('is-active', n === i);
    d.setAttribute('aria-selected', n === i ? 'true' : 'false');
  });
  prev.disabled = (i === 0);
  next.disabled = (i === slides.length - 1);
};

prev.addEventListener('click', () => set(i - 1));
next.addEventListener('click', () => set(i + 1));
dots.forEach(d => d.addEventListener('click', () => set(+d.dataset.index)));

// キーボード操作（左右）
root.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowLeft')  { e.preventDefault(); set(i - 1); }
  if (e.key === 'ArrowRight') { e.preventDefault(); set(i + 1); }
});
// 初期化
set(0);
});

// サイズ切替タブ
document.addEventListener('DOMContentLoaded', () => {
const tabs = document.querySelectorAll('.size__tab');
const panels = document.querySelectorAll('.size__panel');
if (!tabs.length) return;

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const targetId = tab.dataset.target;

    tabs.forEach(t => {
      t.classList.toggle('is-active', t === tab);
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });

    panels.forEach(panel => {
      const active = panel.id === targetId;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  });
});
});

// FAQ
document.addEventListener('DOMContentLoaded', () => {
const items = document.querySelectorAll('.faq__item');
if (!items.length) return;

items.forEach(item => {
  const btn = item.querySelector('.faq__btn');
  const panel = item.querySelector('.faq__a');

  btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') === 'true';

    // すべて閉じる
    document.querySelectorAll('.faq__btn').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.faq__a').forEach(p => p.hidden = true);

    // クリック対象をトグル
    if (!open) {
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  });
});
});


// scroll top
// トップへ戻る（競合対策）
window.addEventListener('load', () => {
const container = document.querySelector('.loosy-main');
const goTop = () => {
  if (container && container.scrollHeight > container.clientHeight) {
    container.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

// クリック
document.querySelectorAll('.scroll-top').forEach(el => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    goTop();
  }, { capture: true });

  // キーボード（Enter/Space）
  el.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      goTop();
    }
  });
});
});

// floating video
(() => {
const floating = document.getElementById('floatingVideo');
const closeBtn = document.getElementById('closeVideo');
const v = floating?.querySelector('video');
if (!floating || !closeBtn) return;

let isOpen = false; // 全画面中かどうか

// 初期状態では表示
floating.style.display = 'block';

// 小さい状態クリック → 全画面に
floating.addEventListener('click', (e) => {
  if (e.target === closeBtn) return; // ✕は別処理
  if (isOpen) return;
  openFull();
});

// ✕クリック → 状態で処理を分ける
closeBtn.addEventListener('click', (e) => {
  e.stopPropagation();
  e.stopImmediatePropagation();

  if (isOpen) {
    // 全画面中なら左下に戻す
    closeFull();
  } else {
    // 小さい状態なら非表示
    hideVideo();
  }
});

// ESCキーでも全画面を閉じる
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && isOpen) closeFull();
});

// ===== 動作関数 =====
function openFull() {
  isOpen = true;
  document.body.classList.add('-no-scroll');
  floating.classList.add('is-open');

  floating.style.display = 'block';
  floating.style.top = '0';
  floating.style.right = '0';
  floating.style.bottom = '0';
  floating.style.left = '0';
  floating.style.width = '100vw';
  floating.style.height = '100vh';
  floating.style.background = '#000';

  if (v) { try { v.play(); } catch(_){} }
}

function closeFull() {
  isOpen = false;
  document.body.classList.remove('-no-scroll');
  floating.classList.remove('is-open');

  floating.style.top = 'auto';
  floating.style.right = 'auto';
  floating.style.bottom = '76px';
  floating.style.left = '16px';
  floating.style.width = '104px';
  floating.style.height = 'auto';
  floating.style.background = '#000';
  floating.style.display = 'block';
}

function hideVideo() {
  floating.style.display = 'none';
  isOpen = false;
}
})();

// smooth scroll
// ==== ページ内リンク（確実に発火するように window.load 後に登録）====
window.addEventListener('load', () => {
console.log('Smooth scroll script loaded ✅');

document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]:not([href="#"])');
  if (!a) return;

  console.log('リンククリック検出✅', a);

  const id = decodeURIComponent(a.getAttribute('href').slice(1));
  const target = document.getElementById(id);
  if (!target) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const container = document.querySelector('.loosy-main');
  const offset = 80;

  if (container && container.scrollHeight > container.clientHeight) {
    const top =
      target.getBoundingClientRect().top -
      container.getBoundingClientRect().top +
      container.scrollTop -
      offset;

    console.log('スクロール対象: .loosy-main', top);
    container.scrollTo({ top, behavior: 'smooth' });
  } else {
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    console.log('スクロール対象: window', top);
    window.scrollTo({ top, behavior: 'smooth' });
  }
}, true);
});

// 商品一覧タブ切り替え
(() => {
  if (window.__LOOSY_PRODUCTS_TABS_V2__) return;
  window.__LOOSY_PRODUCTS_TABS_V2__ = true;

  const SECTION = '.js-products-instance';
  const TAB     = '.products__tabs .js-tab-item';
  const PANEL   = '.js-panel-item';

  const setActive = (sectionEl, activeBtn) => {
    const targetId   = activeBtn.getAttribute('data-target');
    const targetLink = activeBtn.getAttribute('data-link');

    // 念のため：target panel が無ければ全消ししない
    const targetPanel = sectionEl.querySelector(`#${CSS.escape(targetId)}`);
    if (!targetPanel) return;

    // tabs（このsectionだけ）
    sectionEl.querySelectorAll(TAB).forEach(btn => {
      const on = btn === activeBtn;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    // panels（このsectionだけ）
    sectionEl.querySelectorAll(PANEL).forEach(panel => {
      const on = panel.id === targetId;
      panel.hidden = !on;
      panel.style.display = on ? '' : 'none';
      panel.classList.toggle('is-active', on);
    });

    // more（このsectionだけ）
    const label = sectionEl.querySelector('.js-more-label');
    const link  = sectionEl.querySelector('.js-more-link');
    if (label) label.textContent = activeBtn.textContent.trim();
    if (link && targetLink) link.href = targetLink;
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SECTION).forEach(sectionEl => {
      if (sectionEl.dataset.tabsInitialized === 'true') return;

      const tabs = sectionEl.querySelectorAll(TAB);
      const panels = sectionEl.querySelectorAll(PANEL);
      if (!tabs.length || !panels.length) return;

      const activeBtn = sectionEl.querySelector(`${TAB}.is-active`) || tabs[0];
      setActive(sectionEl, activeBtn);

      sectionEl.dataset.tabsInitialized = 'true';
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(TAB);
    if (!btn) return;

    const sectionEl = btn.closest(SECTION);
    if (!sectionEl) return;

    // 他の“全体タブ制御”を止める
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // 自分だけ実行
    setActive(sectionEl, btn);
  }, true);

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // テーマエディタ
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll(SECTION).forEach(sec => {
      sec.dataset.tabsInitialized = 'false';
    });
    initAll(e.target);
  });
})();


(() => {
  const header = document.querySelector('.page-loosy-lp .header');
  const floatingBtn = document.querySelector('.loosy-floating-button');
  const loosyMain = document.getElementById('loosyMain');
  // ヘッダーより上に出るバー（カウントダウン・メンズLP用バー・お知らせバー）。複数あれば高さを合算する
  // ※お知らせバーを本文内（#loosyMain内）に出す設定の場合はヘッダーより上に来ないため除外
  const announcebars = [...document.querySelectorAll('.lp-v33-hero__countdown, #shopify-section-loosy-announcebar, body.loosy-lp #shopify-section-toolbar')]
    .filter(el => !(el.id === 'shopify-section-toolbar' && el.closest('#loosyMain')));
  if (!header) return;

  const setHeaderHeightVar = () => {
    document.documentElement.style.setProperty('--loosy-header-h', header.offsetHeight + 'px');
  };
  const setAnnouncebarHeightVar = () => {
    let h = 0;
    announcebars.forEach(el => { h += el.offsetHeight; });
    document.documentElement.style.setProperty('--loosy-announcebar-h', h + 'px');
  };

  setHeaderHeightVar();
  setAnnouncebarHeightVar();

  // 高さが動的に変わっても追従させる（文字折り返し・カウントダウン幅変化などに対応）
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(() => {
      setHeaderHeightVar();
      setAnnouncebarHeightVar();
    });
    ro.observe(header);
    announcebars.forEach(el => ro.observe(el));
  } else {
    window.addEventListener('resize', () => {
      setHeaderHeightVar();
      setAnnouncebarHeightVar();
    });
  }

  let lastScrollY = 0;
  let ticking = false;
  const threshold = 8;
  const showAtTop = 40;

  const handleScroll = (scrollTop) => {
    if (scrollTop <= showAtTop) {
      header.classList.remove('is-header-hidden');
      floatingBtn?.classList.remove('is-btn-hidden');
      lastScrollY = scrollTop;
      return;
    }
    const diff = scrollTop - lastScrollY;
    if (Math.abs(diff) < threshold) return;

    if (diff > 0) {
      header.classList.add('is-header-hidden');
      floatingBtn?.classList.add('is-btn-hidden');
    } else {
      header.classList.remove('is-header-hidden');
      floatingBtn?.classList.remove('is-btn-hidden');
    }
    lastScrollY = scrollTop;
  };

  const onScroll = (scrollTop) => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      handleScroll(scrollTop);
      ticking = false;
    });
  };

  window.addEventListener('scroll', () => {
    onScroll(window.scrollY || document.documentElement.scrollTop);
  }, { passive: true });

  if (loosyMain) {
    loosyMain.addEventListener('scroll', () => {
      onScroll(loosyMain.scrollTop);
    }, { passive: true });
  }
})();